import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
} from '@angular/core';
import { FormControlStatus } from '@angular/forms';
import { CustomRequisitionPrecedent } from '@models/requisitions';
import { TestHooks } from './new-custom-requisition-view.hooks';

@Component({
	selector: 'app-new-custom-requisition-view',
	templateUrl: './new-custom-requisition-view.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	host: { class: 'h-full' },
})
export class NewCustomRequisitionViewComponent {
	testHooks = TestHooks;
	public selectedRequisitionId_ = input<string>('', {
		alias: 'selectedRequisitionId',
	});
	public isDisabled_ = input<boolean>(false, { alias: 'isDisabled' });
	public loading_ = input<boolean>(false, { alias: 'loading' });
	public secondaryButtonLabel_ = input('Cancel', {
		alias: 'secondaryButtonLabel',
	});
	public onSubmit = output<CustomRequisitionPrecedent>();
	public onFormStatusChange = output<FormControlStatus>();
	public onSecondaryButtonClick = output<void>();
}
